import * as Sentry from '@sentry/browser'; // eslint-disable-line import/no-namespace

const captureException = (exception, options = {}) => {
  const {req, calledFrom, errorInfo, ssr, context} = options;

  try {
    Sentry.withScope(scope => {
      if (typeof ssr !== 'undefined') {
        scope.setTag('ssr', ssr);
      }
      if (req) {
        scope.setExtra('url', req.url);
        scope.setExtra('params', req.params);
        scope.setExtra('query', req.query);
        scope.setExtra('headers', req.headers);
      }
      if (calledFrom) {
        scope.setExtra('calledFrom', calledFrom);
      }
      if (errorInfo) {
        scope.setExtra('errorInfo', errorInfo);
      }
      if (context) {
        scope.setExtra('context', context);
      }

      Sentry.captureException(exception);
    });
  } catch (sentryError) {
    // eslint-disable-next-line no-console
    console.error('error reporting event to Sentry', sentryError);
    return null;
  }

  return Sentry.lastEventId();
};

export default captureException;
